// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

var nbsp = String.fromCharCode(160);

function currTimeStr(param) {
  return new Date(Date.now()).toISOString();
}

function floatToPctStr(pct) {
  return String(Math.round(pct * 100) | 0) + "%";
}

function cacheMake(recalc, depVerEq) {
  return {
          recalc: recalc,
          depVerEq: depVerEq,
          depVer: undefined,
          data: undefined
        };
}

function cacheGetByDepVer(cache, depVer) {
  var cachedDepVer = cache.depVer;
  if (cachedDepVer !== undefined && Curry._2(cache.depVerEq, Caml_option.valFromOption(cachedDepVer), depVer)) {
    return cache.data;
  }
  
}

function cacheGet(cache, depVer, dep) {
  var data = cacheGetByDepVer(cache, depVer);
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  }
  cache.depVer = Caml_option.some(depVer);
  var data$1 = Curry._1(cache.recalc, dep);
  cache.data = Caml_option.some(data$1);
  return data$1;
}

function splitByRegex(str, regex) {
  return str.split(regex).map(function (strOpt) {
                return Belt_Option.getWithDefault(strOpt, "").trim();
              }).filter(function (str) {
              return str.length > 0;
            });
}

var newLineRegex = /[\n\r]/;

function multilineTextToNonEmptyLines(__x) {
  return splitByRegex(__x, newLineRegex);
}

var whitespaceDelimRegex = /[\s\n\r]/;

function getSpaceSeparatedValuesAsArray(__x) {
  return splitByRegex(__x, whitespaceDelimRegex);
}

var plusSignRegex = /\+/g;

var minusSignRegex = /-/g;

var forwardSlashSignRegex = /\//g;

var underscoreSignRegex = /_/g;

function strToSafeBase64(str) {
  return btoa(str).replace(plusSignRegex, "-").replace(forwardSlashSignRegex, "_");
}

function safeBase64ToStr(safeBase64) {
  return atob(safeBase64.replace(underscoreSignRegex, "/").replace(minusSignRegex, "+"));
}

function strToBase64(prim) {
  return btoa(prim);
}

function base64ToStr(prim) {
  return atob(prim);
}

function $$setTimeout$1(prim0, prim1) {
  return setTimeout(prim0, prim1);
}

function $$clearTimeout$1(prim) {
  clearTimeout(prim);
}

exports.nbsp = nbsp;
exports.currTimeStr = currTimeStr;
exports.floatToPctStr = floatToPctStr;
exports.cacheMake = cacheMake;
exports.cacheGetByDepVer = cacheGetByDepVer;
exports.cacheGet = cacheGet;
exports.multilineTextToNonEmptyLines = multilineTextToNonEmptyLines;
exports.getSpaceSeparatedValuesAsArray = getSpaceSeparatedValuesAsArray;
exports.strToBase64 = strToBase64;
exports.base64ToStr = base64ToStr;
exports.strToSafeBase64 = strToSafeBase64;
exports.safeBase64ToStr = safeBase64ToStr;
exports.$$setTimeout = $$setTimeout$1;
exports.$$clearTimeout = $$clearTimeout$1;
/* nbsp Not a pure module */
